import React from "react";

function Upto() {
  return (
    <section id="upto" className="projects">
      <h2> I solemnly swear, I'm upto no good... kidding..😂 </h2>
      <div>
        <p>
          These days, I'm diving into DevOps and cloud technologies like{" "}
          <strong>Docker</strong>,<strong>Kubernetes</strong>, and{" "}
          <strong>AWS</strong>, while also dabbling a bit in frontend
          development with <strong>React</strong>, <strong>HTML</strong>,{" "}
          <strong>CSS</strong>, and <strong>JavaScript</strong> as you can see,
          I've built this website. I'm refining my microservices architecture,
          experimenting with GraphQL, Kafka , MongoDB and CI/CD pipelines, and
          generally learning, building, and sprinkling a bit of fun into
          everything I do 🎨. If you have an exciting project or opportunity,{" "}
          <strong>feel free to contact me</strong> , I'm always up for
          challenges, collaboration, and creating something awesome!
        </p>
        {/* <p>I'm building an app, sshh!...🤫 It's a secret for now</p> */}
      </div>
    </section>
  );
}

export default Upto;
